import * as React from "react";

export const IconImage = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_20165_16546)">
      <path d="M28.5 25.3333V6.66667C28.5 5.2 27.3 4 25.8333 4H7.16667C5.7 4 4.5 5.2 4.5 6.66667V25.3333C4.5 26.8 5.7 28 7.16667 28H25.8333C27.3 28 28.5 26.8 28.5 25.3333ZM11.8333 18L15.1667 22.0133L19.8333 16L25.8333 24H7.16667L11.8333 18Z" fill="#5A6063"/>
      </g>
      <defs>
      <clipPath id="clip0_20165_16546">
      <rect width="32" height="32" fill="white" transform="translate(0.5)"/>
      </clipPath>
      </defs>
    </svg>
  );
};
